import ArrowLeft from "@mui/icons-material/ArrowLeft";
import ArrowRight from "@mui/icons-material/ArrowRight";
import colors from "../theme";

export const datePickerSx = {
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: colors.secondary,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.secondary,
    },
  },
  "& .MuiInputLabel-root": {
    "&.Mui-focused": {
      color: colors.secondary,
    },
  },
  "& .MuiSvgIcon-root": {
    color: colors.secondary,
  },
};

export const datePickerSlots = {
  leftArrowIcon: ArrowLeft,
  rightArrowIcon: ArrowRight,
};

export const datePickerSlotProps = {
  dialog: {
    sx: {
      "& .MuiDialog-paper": {
        overflow: "auto",
        maxHeight: "110vh",
        backgroundColor: colors.mainContentBgColor,
      },
    },
  },
  actionBar: {
    sx: {
      "& .MuiButtonBase-root": {
        color: colors.secondary,
        "&:hover": {
          backgroundColor: colors.secondary,
        },
      },
    },
  },
  layout: {
    sx: {
      backgroundColor: colors.mainContentBgColor,
      "& .MuiDayCalendar-weekDayLabel": {
        color: colors.secondary,
      },
      "& .MuiPickersDay-root": {
        "&.Mui-selected": {
          backgroundColor: `${colors.secondary} !important`,
          color: colors.text,
        },
      },
      "& .MuiPickersMonth-monthButton": {
        "&.Mui-selected": {
          backgroundColor: `${colors.secondary} !important`,
          color: colors.text,
        },
      },
      "& .MuiPickersYear-yearButton": {
        "&.Mui-selected": {
          backgroundColor: `${colors.secondary} !important`,
          color: colors.text,
        },
      },
      "& .MuiPickersCalendarHeader-switchViewIcon": {
        color: colors.secondary,
      },
      "& .MuiPickersCalendarHeader-label": {
        color: "black",
      },
    },
  },
  leftArrowIcon: {
    sx: {
      color: colors.secondary,
    },
  },
  rightArrowIcon: {
    sx: {
      color: colors.secondary,
    },
  },
};
